import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { navSelector } from 'common/store/modules/events-listing/selectors';
import { UPDATE_NAV_ITEM } from 'common/store/modules/events-listing/actions';

export const Date = ({ events, localTimezone }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);

    const timezone = localTimezone ? localTimezone : 'Australia/Melbourne';
    const dates = PULSE.app.common.events.getEventDates(events, timezone);

    return (
        <div className="events-listing-nav__date">
            <ul className="events-listing-nav__date-list">
                {dates.map((date) => (
                    <li
                        key={date.replace('/', '')}
                        className="events-listing-nav__date-item"
                    >
                        <button
                            className={`events-listing-nav__date-button ${
                                nav.date === date ? 'is-active' : ''
                            }`}
                            onClick={(event) => {
                                event.preventDefault();
                                dispatch(
                                    UPDATE_NAV_ITEM.request({
                                        navItem: 'date',
                                        value: date
                                    })
                                );
                            }}
                        >
                            <time>{moment(date).format('ddd MMM D')}</time>
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

Date.propTypes = {
    events: PropTypes.array.isRequired,
    localTimezone: PropTypes.string
};
